import styled from "styled-components";

export const InfoModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  height: 100vh;
  overflow: hidden;
  z-index: 9999;
  background: ${(props) => props.theme.fadedBackground};
`;

export const InfoModalContainer = styled.div`
  position: absolute;
  top: 25px;
  left: -200px;
  color: ${(props) => props.theme.black};
  max-width: 50rem;
  width: 190px;
  margin: 0 2.4rem;
  padding: 1.2rem 1.2rem;
  background-color: ${(props) => props.theme.white};
  border-radius: 0.4rem;
  z-index: 99999;
  border: 1px solid ${(props) => props.theme.black};

`;

export const Info = styled.div`
  cursor: pointer;
`